export var CALL_REFERENCE_FOR_CURRENCY;
(function (CALL_REFERENCE_FOR_CURRENCY) {
    CALL_REFERENCE_FOR_CURRENCY["GET_TOKEN_BALANCE"] = "balance_";
    CALL_REFERENCE_FOR_CURRENCY["GET_TOKEN_APPROVAL"] = "approved_";
})(CALL_REFERENCE_FOR_CURRENCY || (CALL_REFERENCE_FOR_CURRENCY = {}));
